export const findTypeFormEventsByClinicId = /* GraphQL */ `
  query FindTypeFormEventsByClinicId(
    $clinicID: ID!
    $startTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTypeFormEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    findTypeFormEventsByClinicId(
      clinicID: $clinicID
      startTime: $startTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        doctor {
          drId
          drName
        }
        definitionSubject
        startTime
      }
      nextToken
    }
  }
`
